import { defineStore } from 'pinia'
import type GlobalStoreI from '@/typescript/types/stores/GlobalStoreI'
import type { GlobalState } from '@/typescript/types/stores/GlobalStoreI'

export const useGlobalStore: GlobalStoreI = defineStore('global', {
  state: () => ({}) as GlobalState,
  getters: {},
  actions: {},
})
